import React, { ChangeEventHandler, useEffect, useState } from 'react'
import {
  CButton,
  CCol,
  CForm,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CRow,
} from '@coreui/react-pro'
import { submitAiMagic } from '../../details/model'

type TProps = {
  data: {
    aiAssessment: number
    aiMagic: number
  }
  isOpen?: boolean
  onCancel: () => void
}
export const SetSortingModal: React.FC<TProps> = ({
  data,
  isOpen,
  onCancel,
}) => {
  const [aiAssessmentValue, setAIAssessmentValue] = useState('')
  const handleSubmit = () => {
    submitAiMagic({ aiMagic: Number(aiAssessmentValue) })
    onCancel()
    setAIAssessmentValue('')
  }
  const handleChangedAi = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (Number(e.target.value) > -1000 && Number(e.target.value) < 1000)
      setAIAssessmentValue(e.target.value)
  }

  return (
    <CModal
      visible={isOpen}
      onClose={() => {
        onCancel()
        setAIAssessmentValue('')
      }}
    >
      <CModalHeader>Set sorting</CModalHeader>
      <CModalBody>
        <CForm>
          <div>{`Current AI Assessment: ${data.aiAssessment}`}</div>
          <div>{`Current AI Magic: ${data.aiMagic}`}</div>
          <CRow className="mb-3">
            <CFormLabel
              htmlFor="aiAssessment"
              className="col-sm-3 col-form-label"
            >
              AI Magic
            </CFormLabel>
            <CCol sm={8}>
              <CFormInput
                size="sm"
                type="number"
                min="-999"
                max="999"
                id="aiAssessment"
                value={aiAssessmentValue}
                onChange={(event) => handleChangedAi(event)}
              />
            </CCol>
          </CRow>
        </CForm>
      </CModalBody>
      <CModalFooter>
        <CButton
          color="secondary"
          onClick={() => {
            onCancel()
            setAIAssessmentValue('')
          }}
        >
          Cancel
        </CButton>
        <CButton color="primary" className="px-4" onClick={handleSubmit}>
          Add
        </CButton>
      </CModalFooter>
    </CModal>
  )
}
